const mobnavToggler = 'mobnav-toggler',
    navElement = 'nav-dropdown-wrapper',
    mobnavPaneToggler = 'mobnav-pane-toggler',
    mobnavPane = 'pane-menu';

export class NavigationNew {
    
    constructor() {
        this.setActiveId = this.setActiveId.bind(this);
        this.removeActiveId = this.removeActiveId.bind(this);
        this.toggleActive = this.toggleActive.bind(this);
        this.init = this.init.bind(this);
        this.toggleActiveArray = this.toggleActiveArray.bind(this);
        this.closeAccount = this.closeAccount.bind(this);
        this.subPaneHandle();
        this.openAccount();
        this.closeAccountClick();
    }

    init() {
        /**
         * Uses: toggleActive() to trigger "active" class and open the navigation on mobile
         */
        if ($('.nav5-component').length !== 0) {
            document.getElementById(mobnavToggler).addEventListener('click', () => {
                this.navToggleBehavior(mobnavToggler)
            });
        } else {
            return false;
        }

        const mobnavPaneTogglers = document.getElementsByClassName(mobnavPaneToggler);
        for (let i = 0; i < mobnavPaneTogglers.length; i++) {
            mobnavPaneTogglers[i].addEventListener('click', () => {
                let thisId = mobnavPaneTogglers[i].id,
                    thisTarget = mobnavPaneTogglers[i].getAttribute('data-toggle-target'),
                    removeActiveClassFromTargetClassName = document.getElementById(thisTarget).classList;
                this.removeActive(mobnavPaneToggler);
                this.toggleActive(thisId);
                this.removeActive(mobnavPane);
                this.toggleActive(thisTarget);
            });
        }

        // Toggle Search functionality on desktop
        const searchTrigers = document.getElementsByClassName('search-trigger');

        for (let i = 0; i < searchTrigers.length; i++) {
            searchTrigers[i].addEventListener('click', (e) => {
                e.preventDefault();
                if (!this.isActive('nav-search-desktop')) {
                    document.getElementById('nav-search-input').focus();
                    document.getElementById('nav-search-desktop').classList.add("active");
                    $('#nav-search-desktop').removeClass('d-none');
                    $('.search-trigger').removeClass('d-lg-inline-block');
                    $('#nav-search-desktop form button').removeClass('d-none');
                }
            });
        }

        $('#nav-search-desktop form button').on('click', (e) => {
            $('#nav-search-desktop form button').data('clicked', true);
        })

        $('#nav-search-desktop form').on('focusout', () => {
            setTimeout(() => {
                if (!$('#nav-search-desktop form button').data('clicked')) {
                    $('#nav-search-desktop').removeClass('active');
                    $('#nav-search-desktop').addClass('d-none');
                    setTimeout(() => {
                        $('.search-trigger').addClass('d-lg-inline-block');
                    }, 250)
                }
            }, 100);
        });

        // Define our viewportWidth variable
        var viewportWidth;
        // Set/update the viewportWidth value
        var setViewportWidth = () => {
            viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        }

        // Log the viewport width into the console
        var logWidth = (windowWidth) => {
            // Clear focus from input upon width change
            document.getElementById('nav-search-input').blur();
            if (viewportWidth > 991) {
                this.removeActive('nav5-component .active');
                var navToggler = document.getElementsByClassName('nav-active-area');

                // upscroll code
                var elHasClass = document.getElementById('main-navigation-bar').classList.contains('scrolldown');
                if (elHasClass) {
                    document.getElementById('main-navigation-bar').classList.remove('scrolldown');
                }
            } else {

                if ($('nav5-component .active') && windowWidth !== window.innerWidth) {
                    this.removeActive('nav5-component .active');
                }
                var lastScrollTop = 0;
                // element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
                document.addEventListener("scroll", () => { // or window.addEventListener("scroll"....
                    var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
                    if (st > lastScrollTop) {
                        // downscroll code
                        var elHasClass = document.getElementById('main-navigation-bar').classList.contains('scrolldown');
                        if (!elHasClass && !this.isActive(navElement)) {
                            document.getElementById('main-navigation-bar').classList.add('scrolldown');
                        }
                    } else {
                        // upscroll code
                        var elHasClass = document.getElementById('main-navigation-bar').classList.contains('scrolldown');
                        if (elHasClass) {
                            document.getElementById('main-navigation-bar').classList.remove('scrolldown');
                        }
                    }
                    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
                }, false);
            }
        }
        // Set our initial width and log it
        const initWindowWidth = window.innerWidth;
        setViewportWidth();
        logWidth(initWindowWidth);
        // On resize events, recalculate and log
        window.addEventListener('resize', () => {
            $('body').removeClass('prevent-page-scrolling');
            setViewportWidth();
            logWidth(initWindowWidth);
        });

        var navToggler = document.getElementsByClassName('nav-active-area');

        for (let i = 0; i < navToggler.length; i++) {
            var mouseOutside = false;
            navToggler[i].addEventListener('mouseleave', () => {
                mouseOutside = true;
                if (viewportWidth > 991) {
                    setTimeout(() => {
                        if (mouseOutside) {
                            //$( 'body' ).css( 'background-color', 'white' );
                            this.removeActiveId(navElement);
                        }
                    }, 200);
                }
            });

            //removeActiveId( navElement );

            navToggler[i].addEventListener('mouseover', () => {
                if (viewportWidth > 991) {
                    mouseOutside = false;
                    this.setActiveId(navElement);
                    // $( 'body' ).css( 'background-color', 'rgba(0,0,0,0.47)' );
                }
            });
        }

        const desktopNavList = document.getElementsByClassName('desktop-nav-list-item');
        for (let i = 0; i < desktopNavList.length; i++) {
            let thisTarget = desktopNavList[i].getAttribute('data-toggle-target');
            desktopNavList[i].addEventListener('mouseenter', () => {
                this.removeActive(mobnavPane);
                this.setActiveId(thisTarget);
                $('.desktop-nav-list-item').removeClass('active');
                $('.desktop-nav-list-item[data-toggle-target="' + thisTarget + '"]').addClass('active');
            });
        }
    }
    /**
     * Check if element has "active" class and return bool true/false
     */
    isActive(e) {
        if (document.getElementById(e).classList.contains('active')) {
            return document.getElementById(e).classList.contains('active');
        }
    };

    /**
     * Add "active" class if element doesn't have "active" class, otherwise remove it
     */
    toggleActive(e) {
        if (!this.isActive(e)) {
            document.getElementById(e).classList.add('active');
        } else {
            document.getElementById(e).classList.remove('active');
        }
    };

    /**
     * Set "active" from all elements with className
     */
    setActiveId(e) {
        if (!this.isActive(e)) {
            document.getElementById(e).classList.add('active');
        }
    };

    /**
     * Set "active" from all elements with className
     */
    removeActiveId(e) {
        if (this.isActive(e)) {
            document.getElementById(e).classList.remove('active');
        }
    };

    /**
     * Remove "active" from all elements with className
     */
    removeActive(e) {
        const eList = document.querySelectorAll('.' + e);
        for (var i = 0; i < eList.length; i++) {
            eList[i].classList.remove('active');
        }
    };

    toggleActiveArray(elementClass) {
        let eArray = document.getElementsByClassName(elementClass);
        for (var i = 0; i < eArray.length; i++) {

            let toggleTarget = eArray[i].getAttribute('data-toggle-target');

            eArray[i].addEventListener('click', function () {
                if (!this.isActive(eArray[i])) {

                    for (var ii = 0; ii < eArray.length; ii++) {
                        eArray[ii].classList.add('active');
                    }
                    if (document.getElementById(toggleTarget)) {
                        document.getElementById(toggleTarget).classList.add('active');
                    }
                }
            });
        }
    };

    /**
     * Reset movile navigation to default every time it's closed
     */
    navToggleBehavior(e) {
        const wrapperActivePaneDestop = $('.wrapper-active-pane div');
        const wrapperActivePaneMobile = $('#nav-dropdown-wrapper div .mobnav-pane-toggler');

        if (!this.isActive(e)) {
            // this.removeActive( 'nav5-component .active' );
            this.toggleActive(mobnavToggler);
            this.toggleActive(navElement);
            this.toggleActive(wrapperActivePaneDestop.get(0).id);
            this.toggleActive(wrapperActivePaneMobile.get(0).id);
            $('body').addClass('prevent-page-scrolling');
        } else {
            $('body').removeClass('prevent-page-scrolling');
            this.removeActive('nav5-component .active');
        }
    };

    subPaneHandle() {
        const subpaneTogglers = document.querySelectorAll('.subpane-toggler');
        const subpaneTabs = document.querySelectorAll('.subpane-tab');
        for (let i = 0; i < subpaneTogglers.length; i++) {
            let subpaneTogglerTarget = subpaneTogglers[i].getAttribute('data-subpane-id');
            subpaneTogglers[i].onmouseenter = function (evt) {
                $(subpaneTogglers).removeClass('subpane-toggler-active');
                if (document.getElementById(subpaneTogglerTarget)) {
                    for (let j = 0; j < subpaneTabs.length; j++) {
                        subpaneTabs[j].style.display = "none";
                        if (subpaneTogglers[i]) {
                            $(this).addClass('subpane-toggler-active');
                        }
                    }
                    if (document.getElementById(subpaneTogglerTarget)) {
                        const element = document.getElementById(subpaneTogglerTarget)
                        element.style.display = 'block';
                    }
                }
            };
        }
    }

    openAccount() {
        const searchTrigers = document.getElementsByClassName('account-toggler');
        for (let i = 0; i < searchTrigers.length; i++) {
            const _this = this;
            searchTrigers[i].addEventListener('click', function (e) {
                e.preventDefault();
                if ($('.customer-account-layer-background').length > 0) {
                    $('#customer-account-page').addClass('d-none');
                    $('.customer-account-layer').removeClass('customer-account-layer-background');
                } else {
                    if ($('#mobnav-toggler.active').length) {
                        _this.navToggleBehavior(mobnavToggler);
                    }
                    $('#customer-account-page').removeClass('d-none');
                    $('.customer-account-layer').addClass('customer-account-layer-background');
                }
            });
        }
    }

    closeAccountClick() {
        $('.customer-account-layer').on('click', (e) => {
            e.preventDefault();
            this.closeAccount();
        });
    }

    closeAccount() {
        if (!$('#customer-account-page').hasClass('d-none')) {
            $('#customer-account-page').addClass('d-none');
            $('.customer-account-layer').removeClass('customer-account-layer-background');
        }
    }
}